export enum TabsPayments {
  pending = 0,
  history = 1
}

interface PaymentTable {
  id: number;
  date: string,
  price: string,
  status: string
}

export interface PaymentTableHistory extends PaymentTable {
  receiptNumber: string,
  invoiceNumber: string
}

export interface PaymentTablePending extends PaymentTable {
  expirationDate: string,
  pdfUrl: string,
  saleId: number
}

export enum TypePaymentTable {
  pending = "pending",
  history = "history"
}

export interface PaymentSummary {
  summary: {
    salePaidQty: number,
    salePendingQty: number
  },
  sales: Sales[]
}

export interface Sales {
  saleId: number,
  totalAmount: number,
  paymentStatus: PaymentStatus,
  receiptNumber: string,
  invoiceNumber: string,
  saleDate: string
}

export enum PaymentStatus {
  credited = "Credited",
  creditAccount = "CreditAccount"
}

export interface Proformas {
  id: number,
  saleId: number,
  pdfUrl: string,
  createdAt: string,
  totalAmount: number,
  expirationAt: string,
  creditAccountStatus: string
}

export interface ProformasResponse {
  bills: Proformas[];
  totalCount: number;
}

export enum PaymentStatusProforma {
  pending = "PaymentInProcess",
  toPay = "ToPay"
}